import type { ChangeEvent } from 'react';

export const RTI_TEXT_MAX_LENGTH = 3000;

export function parseOdsTextareaValue(raw: unknown): string {
  if (typeof raw === 'string') return raw;
  if (raw && typeof raw === 'object' && 'target' in raw) {
    const t = (raw as ChangeEvent<HTMLTextAreaElement>).target?.value;
    if (typeof t === 'string') return t;
  }
  return '';
}

export type RtiDescriptionFieldProps = {
  id: string;
  label: string;
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
  onBlur: () => void;
  disabled?: boolean;
};

const textareaClassName =
  'w-full resize-y rounded border border-[#C5C7CA] px-3 py-2 font-ods-font-family-secondary text-ods-font-styles-body-regular-small text-[#1D1D1D] placeholder:text-[#747373] placeholder:font-normal focus:border-[#005CC7] focus:outline-none focus:ring-1 focus:ring-[#005CC7] disabled:opacity-60';

export function RtiDescriptionField({
  id,
  label,
  placeholder,
  value,
  onChange,
  onBlur,
  disabled = false,
}: RtiDescriptionFieldProps) {
  const textareaId = `${id}-textarea`;

  const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    if (disabled) return;
    onChange(e.target.value.slice(0, RTI_TEXT_MAX_LENGTH));
  };

  return (
    <div className='flex w-full flex-col gap-2'>
      <div className='flex items-baseline justify-between gap-4'>
        <label
          className='font-ods-font-family-secondary text-ods-font-styles-body-regular-small font-normal text-[#1D1D1D]'
          htmlFor={textareaId}
        >
          {label}
        </label>
        <span
          className='shrink-0 font-ods-font-family-secondary text-ods-font-styles-body-regular-small font-normal text-[#747373]'
          aria-live='polite'
        >
          {value.length}/{RTI_TEXT_MAX_LENGTH}
        </span>
      </div>
      <textarea
        id={textareaId}
        name={textareaId}
        className={textareaClassName}
        value={value}
        onChange={handleChange}
        onBlur={onBlur}
        placeholder={placeholder}
        maxLength={RTI_TEXT_MAX_LENGTH}
        rows={2}
        spellCheck
        disabled={disabled}
      />
    </div>
  );
}
